// Simple i18n strings for EN / SR

export const STRINGS = {
  brand: { tagline_en: "Direct stays, beautifully kept.", tagline_sr: "Direktan boravak, besprekorno održavan." },
  nav: {
    home: { en: "Home", sr: "Početna" },
    apartments: { en: "Apartments", sr: "Apartmani" },
    services: { en: "Services", sr: "Usluge" },
    about: { en: "About", sr: "O nama" },
    faq: { en: "FAQ", sr: "Pitanja" },
    contact: { en: "Contact", sr: "Kontakt" },
    admin: { en: "Admin", sr: "Admin" },
  },
  hero: {
    eyebrow: { en: "Stilet Residence", sr: "Stilet Residence" },
    title: { en: "A different kind of stay in the city.", sr: "Drugačiji način boravka u gradu." },
    sub: {
      en: "Five private residences in Kotor Bay. Booked directly with us — never through middlemen.",
      sr: "Pet privatnih rezidencija u Boki Kotorskoj. Rezervišete direktno kod nas — bez posrednika.",
    },
    cta_view: { en: "View Apartments", sr: "Pogledaj Apartmane" },
    cta_book: { en: "Book Now", sr: "Rezerviši" },
  },
  home: {
    featured_eyebrow: { en: "Most Loved", sr: "Najtraženiji" },
    featured_title: { en: "Selected residences", sr: "Izabrane rezidencije" },
    featured_sub: { en: "Hand-picked apartments our guests return to.", sr: "Pažljivo birani apartmani kojima se gosti vraćaju." },
    why_eyebrow: { en: "Why Direct", sr: "Zašto Direktno" },
    why_title: { en: "No platforms. No fees. Just hospitality.", sr: "Bez platformi. Bez provizija. Samo gostoprimstvo." },
    why_items: [
      { en: ["No commission", "Booking directly means we keep prices honest and service personal."],
        sr: ["Bez provizije", "Rezervacija direktno znači poštene cene i ličnu uslugu."] },
      { en: ["Verified locations", "Each residence is owned and maintained by our team — no surprises."],
        sr: ["Provereno", "Svaku rezidenciju održava naš tim — bez iznenađenja."] },
      { en: ["Local concierge", "Airport transfers, tours, dinner reservations — one message away."],
        sr: ["Lokalni konsijerž", "Transfer, ture, rezervacije — jedna poruka je dovoljna."] },
    ],
  },
  listings: {
    title: { en: "All Residences", sr: "Sve Rezidencije" },
    filter_location: { en: "Location", sr: "Lokacija" },
    filter_guests: { en: "Guests", sr: "Gosti" },
    filter_max_price: { en: "Max price / night", sr: "Maks. cena / noć" },
    filter_all: { en: "All", sr: "Sve" },
    night: { en: "/ night", sr: "/ noć" },
    view_details: { en: "View Details", sr: "Detaljnije" },
    no_results: { en: "No residences match your filters.", sr: "Nema rezidencija po zadatim filterima." },
    map_title: { en: "On the map", sr: "Na mapi" },
  },
  details: {
    overview: { en: "Overview", sr: "Pregled" },
    amenities: { en: "Amenities", sr: "Sadržaji" },
    house_rules: { en: "House Rules", sr: "Kućni Red" },
    location: { en: "Location", sr: "Lokacija" },
    book_title: { en: "Reserve your stay", sr: "Rezerviši boravak" },
    check_in: { en: "Check-in", sr: "Prijava" },
    check_out: { en: "Check-out", sr: "Odjava" },
    guests: { en: "Guests", sr: "Gosti" },
    nights: { en: "nights", sr: "noći" },
    total: { en: "Total", sr: "Ukupno" },
    book_btn: { en: "Request to Book", sr: "Pošalji Zahtev" },
    rooms: { en: "rooms", sr: "soba" },
    beds: { en: "beds", sr: "kreveta" },
    baths: { en: "baths", sr: "kupatila" },
    sqm: { en: "m²", sr: "m²" },
    extras: { en: "Add services", sr: "Dodatne usluge" },
    your_info: { en: "Your information", sr: "Vaši podaci" },
    full_name: { en: "Full name", sr: "Ime i prezime" },
    email: { en: "Email", sr: "Email" },
    phone: { en: "Phone", sr: "Telefon" },
    message_opt: { en: "Message (optional)", sr: "Poruka (opciono)" },
    success: { en: "Thank you. Your request has been received — we will reply within hours.", sr: "Hvala. Vaš zahtev je primljen — odgovaramo u roku od par sati." },
  },
  services: {
    title: { en: "Concierge Services", sr: "Konsijerž Usluge" },
    sub: { en: "Extras to make your stay effortless.", sr: "Dodaci koji vaš boravak čine bezbrižnim." },
    items: [
      { key: "transfer", en: ["Airport Transfer", "Private sedan to and from Tivat or Podgorica airport.", "from €35"],
        sr: ["Transfer od/do aerodroma", "Privatni transfer od/do aerodroma Tivat ili Podgorica.", "od €35"] },
      { key: "tour", en: ["Private Bay Tour", "Curated boat tours of Kotor Bay — Perast, Our Lady of the Rocks, hidden coves.", "from €80"],
        sr: ["Privatna tura zalivom", "Tura brodom po Boki — Perast, Gospa od Škrpjela, skrivene uvale.", "od €80"] },
      { key: "cleaning", en: ["Mid-stay Cleaning", "Fresh linen, restocked essentials, a quiet reset.", "from €25"],
        sr: ["Čišćenje tokom boravka", "Sveža posteljina, dopuna potrepština, mirni reset.", "od €25"] },
      { key: "bikes", en: ["Bike Rental", "City bikes delivered to your door — perfect for coastal rides.", "from €12 / day"],
        sr: ["Iznajmljivanje bicikla", "Bicikli isporučeni do vrata — savršeno za vožnju duž obale.", "od €12 / dan"] },
    ],
  },
  about: {
    eyebrow: { en: "About Stilet", sr: "O Stiletu" },
    title: { en: "A small studio of hosts, not a hotel chain.", sr: "Mali tim domaćina, ne hotelski lanac." },
    body: {
      en: "Stilet Residence began with one restored apartment in Kotor Bay — a place to host friends visiting Montenegro. Five residences later, our philosophy hasn't changed: thoughtfully designed homes, kept beautifully, offered without intermediaries. When you book with us, you reach us directly. Always.",
      sr: "Stilet Residence je počeo sa jednim obnovljenim stanom u Boki Kotorskoj — mestom za prijatelje koji posećuju Crnu Goru. Pet rezidencija kasnije, naša filozofija je ista: pažljivo dizajnirani domovi, besprekorno održavani, ponuđeni bez posrednika. Kada rezervišete kod nas, dolazite pravo do nas. Uvek.",
    },
  },
  faq: {
    title: { en: "Frequently Asked", sr: "Česta Pitanja" },
    items: [
      { q_en: "How do I book?", a_en: "Send a booking request from any apartment page. We respond within hours with confirmation and payment instructions.",
        q_sr: "Kako rezervišem?", a_sr: "Pošaljite zahtev sa stranice apartmana. Odgovaramo u roku od par sati sa potvrdom i uputstvima za uplatu." },
      { q_en: "What is the cancellation policy?", a_en: "Free cancellation up to 7 days before check-in. After that, 50% refund up to 48h before arrival.",
        q_sr: "Politika otkazivanja?", a_sr: "Besplatno otkazivanje do 7 dana pre prijave. Posle, 50% povraćaja do 48h pre dolaska." },
      { q_en: "Check-in and check-out times?", a_en: "Check-in from 15:00, check-out by 11:00. Early/late on request.",
        q_sr: "Vreme prijave i odjave?", a_sr: "Prijava od 15:00, odjava do 11:00. Ranije/kasnije na zahtev." },
      { q_en: "Do you accept pets?", a_en: "Most residences accept small pets on request. Please mention in your booking message.",
        q_sr: "Da li primate kućne ljubimce?", a_sr: "Većina rezidencija prima male ljubimce na zahtev. Navedite u poruci." },
      { q_en: "Is parking available?", a_en: "Most central residences are in pedestrian zones; we can arrange parking nearby.",
        q_sr: "Da li ima parking?", a_sr: "Većina centralnih rezidencija je u pešačkoj zoni; možemo organizovati parking u blizini." },
    ],
  },
  contact: {
    title: { en: "Get in touch", sr: "Kontaktirajte nas" },
    sub: { en: "We respond personally — usually within a few hours.", sr: "Odgovaramo lično — obično u roku od par sati." },
    name: { en: "Name", sr: "Ime" },
    subject: { en: "Subject", sr: "Tema" },
    message: { en: "Message", sr: "Poruka" },
    send: { en: "Send Message", sr: "Pošalji Poruku" },
    success: { en: "Message received. We'll be in touch shortly.", sr: "Poruka primljena. Javljamo se uskoro." },
    address: { en: "Kotor, Montenegro", sr: "Kotor, Crna Gora" },
  },
  footer: {
    explore: { en: "Explore", sr: "Istraži" },
    rights: { en: "All rights reserved.", sr: "Sva prava zadržana." },
  },
  admin: {
    login_title: { en: "Admin Sign In", sr: "Admin Prijava" },
    email: { en: "Email", sr: "Email" },
    password: { en: "Password", sr: "Lozinka" },
    sign_in: { en: "Sign In", sr: "Prijavi se" },
    dashboard: { en: "Dashboard", sr: "Kontrolna tabla" },
    apartments: { en: "Apartments", sr: "Apartmani" },
    bookings: { en: "Bookings", sr: "Rezervacije" },
    logout: { en: "Logout", sr: "Odjavi se" },
  },
};

export function t(path, lang) {
  // path like "nav.home" -> STRINGS.nav.home[lang]
  const parts = path.split(".");
  let obj = STRINGS;
  for (const p of parts) obj = obj?.[p];
  if (!obj) return path;
  if (typeof obj === "string") return obj;
  return obj[lang] ?? obj.en ?? path;
}
